module.exports = __webpack_public_path__ + "static/media/timesheetsDayLine.4c8debfe.svg";